import RecordRecord from './RecordRecord.vue'
export default RecordRecord



// WEBPACK FOOTER //
// ./src/views/system/recordRecord/index.js